const FolderSizeConfirmModal = ({ item, onCancel, onConfirm }) => {
  if (!item) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/60 p-4 backdrop-blur">
      <div className="glass-panel w-full max-w-md rounded-2xl p-5">
        <h3 className="text-lg font-semibold text-white m-0">Calculate Folder Size</h3>
        <p className="text-sm text-textMuted mt-2">
          This will recursively scan every file inside <span className="text-white font-medium">{item.name}</span> to calculate the total size.
        </p>
        <p className="text-sm text-textMuted mt-2">
          For large folders with many files this may take a while. Please do not navigate away while the calculation is running.
        </p>
        <div className="flex justify-end gap-2 mt-4">
          <button type="button" className="ghost-button" onClick={onCancel}>Cancel</button>
          <button type="button" className="pill-button" onClick={() => onConfirm(item.path, item.name)}>Calculate</button>
        </div>
      </div>
    </div>
  );
};

export default FolderSizeConfirmModal;
